// Partner SSO registry. Mirrors the BE sso-providers.json: the `slug` is the
// key (must match GET {API_BASE_URL}/auth/sso/{slug}/start), and each entry is
// matched with its Cognito IdP name. Adding a partner later = one row here +
// the matching BE provider/slug.

export interface SsoPartner {
  slug: string;
  cognitoIdpName: string;
  displayName: string;
  tagline: string;
}

export const SSO_PARTNERS: Record<string, SsoPartner> = {
  'bits-wilp': {
    slug: 'bits-wilp',
    cognitoIdpName: 'bits-wilp',
    displayName: 'BITS WILP',
    tagline: 'Confidential student support',
  },
};

export function getSsoPartner(slug: string): SsoPartner | null {
  return SSO_PARTNERS[slug] ?? null;
}

// Read straight from the env rather than importing API_BASE_URL from
// '@/lib/api-client': that module imports resolveLogoutDestination, which imports
// this one, and the cycle leaves the constant undefined at module-init time.
const API_BASE: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:8800/api/v1';

/**
 * Full-page logout URL for a partner. Wiping the local tokens is not enough:
 * Cognito holds a session cookie of its own. This BE endpoint bounces
 * through Cognito's /logout and returns the browser to `/sso/<slug>`. It ends
 * this app's session only; the student's Keycloak and BITS sessions are left
 * running on purpose.
 */
export function ssoLogoutUrl(slug: string): string {
  return `${API_BASE}/auth/sso/${encodeURIComponent(slug)}/logout`;
}
